import React, { Component } from 'react';
import clsx from 'clsx';
import { styled } from "@mui/material/styles";
import { CardBody, Media } from 'reactstrap';
import {
    Avatar, Container, Button, Tooltip, Typography, FormControlLabel, Fade, Dialog, DialogActions, DialogContent,
    DialogTitle, Checkbox, Modal, Backdrop,List, ListItem, Box, TextField, MenuItem, Grid, CardContent, Toolbar } from '@mui/material';
import { connect } from 'react-redux';
import Header from './LandHeader';
import withRouterCompat from '../../actions/routerWrapper.jsx'
import AboutModal from './AboutModal';
import VideoModal from './VideoModal';
import ResourceSection from './ResourceSection';
import Footer from './LandFooter';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import InfoIcon from '@mui/icons-material/Info';
import MailOutlineTwoToneIcon from '@mui/icons-material/MailOutlineTwoTone';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import stock1 from '/assets/images/stock-photos/stock-1.jpg';
import Card from "../Card/Card.jsx";
import CardHeader from "../Card/CardHeader.jsx";
import GridItem from "../Grid/GridItem.jsx";
import classnames from "classnames";
import {motion} from 'framer-motion'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {baseUrl} from '../shared/baseUrl';

const hero = "/assets/images/myimage.jpg";



const types = [
    {
        value: 'teacher',
        label: 'Teacher'
    },
    {
        value: 'student',
        label: 'Student'
    }
]







class Landing extends Component {
    constructor() {
        super()
        this.state = {
            open2: false,
            setOpen2: false,
            openvid: false,
            checked1: true,
            setChecked1: true,
            email: "",
            password: "",
            type: 'student',
            errors: {},
            animate:false,
            openAbout:false
        };

        this.handleClickOpen2 = this.handleClickOpen2.bind(this);
        this.handleClose2 = this.handleClose2.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChange1 = this.handleChange1.bind(this);
        this.handleclickvid=this.handleclickvid.bind(this);
        this.handleClosevid=this.handleClosevid.bind(this);
        this.handleCloseAbout = this.handleCloseAbout.bind(this);
        this.handleClickAbout = this.handleClickAbout.bind(this);

    }



    /////variables for onclick login form//////////////////////////

    
    handleChange(event) {
        this.setState({
            type: event.target.value
        });
    }

    handleChange1(event) {
        this.setState({
            setChecked1: event.target.checked
        });
    }



    handleClickOpen2() {
        this.setState({
            open2: !this.state.open2
        });
    }

    handleClose2(event) {
        this.setState({
            open2: !this.state.open2
        });
        
    }

    handleclickvid(){
        this.setState({
        openvid: !this.state.openvid,
        animate: !this.state.animate
        });
    }

    handleClosevid(){
        this.setState({
            openvid: !this.state.openvid
        });
    }

    handleCloseAbout(){
        this.setState({
            openAbout: !this.state.openAbout
        });
    }

    handleClickAbout(){
        this.setState({
        openAbout: !this.state.openAbout,
        });
    }

    componentDidMount() {

        document.body.className = 'page-landing';
        const { location, navigate } = this.props;
        this.currentPathname = location.pathname;
        this.currentSearch = location.search;

        if (!location || !navigate) {
        console.warn('location or navigate props are undefined in Header component');
        return;
        }

        this.currentPathname = location.pathname || '/';
        this.currentSearch = location.search || '';
    
      }

    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });
        }
    }

    onChange = event => {
        this.setState({ [event.target.id]: event.target.value },
        );
    };

    onSubmit = (event) => {
        event.preventDefault();
        
        const { email, password, type } = this.state;
        const { loginUser, history } = this.props;
        
        event.target.reset();
        const userData = { email, password, type };
        loginUser(userData, history);
    };

    /////////////   Variables for Login Form /////////////////
    


    render() {
        const { contentBackground } = this.props;
        const { errors } = this.state;

        return (
                <>
                    <Box sx={{ width: '100%', maxWidth: '100%', overflowX: 'hidden', p: 0,m: 0,}}>
                        <Header />
                          <Box sx={{ height: { xs: 2750, sm: 2750 } }} />
                          
                          <Box
                            sx={{
                            position: 'relative',
                            width: '100%', 
                            minHeight: '100vh',
                            backgroundImage: `url(${hero})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            color:'white'
                            }}
                         >
                            <Box
                            sx={{
                                position: 'absolute',
                                width: '100%',
                                height: '100%',
                                backgroundColor: 'rgba(20, 18, 28, 0.5)',
                                zIndex: 1,
                            }}
                            />

                            <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.5, duration: 0.5 }}
                            style={{
                                zIndex: 2,
                                width: '100%',
                                position: 'relative'///ensure the buttons are clickable
                            }}
                            >
                            <Box sx={{
                                    maxWidth: '100%',
                                    py: 8,
                                    textAlign: 'center',
                                    color: 'white',
                                    px: 2, // Optional horizontal padding you control
                                }}
                                >
                                <Typography variant="h2" fontWeight="bold" gutterBottom>
                                CT-Onlinq
                                </Typography>
                                <motion.p
                                initial={{ y: '-100vw' }}
                                animate={{ y: 0 }}
                                transition={{ delay: 1, duration: 0.5, type: 'spring', stiffness: 120 }}
                                style={{ fontSize: '1.25rem', color: 'rgba(255,255,255,0.8)', marginBottom: 24 }}
                                >
                                Looking for a unique and engaging way to learn computational thinking?
                                Your search ends here!
                                </motion.p>
                                <Box
                                sx={{
                                    width: '60px',
                                    height: '3px',
                                    backgroundColor: 'white',
                                    margin: '0 auto 32px',
                                    borderRadius: '4px',
                                    opacity: 0.6,
                                }}
                                />
                                <motion.div
                                initial={{ x: '-100vw' }}
                                animate={{ x: 0 }}
                                transition={{ delay: 1, duration: 0.5, type: 'spring', stiffness: 120 }}
                                whileHover={{ scale: [1.05, 1, 1.05, 1] }}
                                style={{ display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap' }}
                                >
                                <Button
                                    onClick={this.handleClickAbout}
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    startIcon={<InfoIcon />}
                                >
                                    About Us
                                </Button>
                                <Button
                                    onClick={this.handleclickvid}
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    startIcon={<PlayCircleOutlineIcon />}
                                >
                                    Watch Video
                                </Button>
                                </motion.div>
                            </Box>
                            </motion.div>
                       
                            
                            <AboutModal open={this.state.openAbout} handleClose={this.handleCloseAbout} />


                            <VideoModal open={this.state.openvid} handleClose={this.handleClosevid} />

                            <Dialog
                                open={this.state.open2}
                                maxWidth={'xs'}
                                fullWidth={true}
                                onClose={this.handleClose2}
                                aria-labelledby="form-dialog-title2">
                                <DialogTitle id="form-dialog-title">Sign in with your credentials</DialogTitle>
                                <form noValidate onSubmit={this.onSubmit}>
                                    <DialogContent>
                                    <div className="card-header d-block bg-white pt-4 pb-5">
                                        <div className="text-center mb-3">
                                            <span><b>Sign in with</b></span>
                                        </div>
                                        <div className="text-center">
                                            <Button variant="outlined" className="mr-2 text-facebook">
                                            <span className="btn-wrapper--icon">
                                                <MailOutlineTwoToneIcon />
                                            </span>
                                            <span className="btn-wrapper--label">Gmail</span>
                                            </Button> 
                                        </div>
                                    </div>
                                    <div className="text-center mb-3">
                                        <span> <b>OR</b></span>
                                    </div>
                                        <div>
                                            <MailOutlineTwoToneIcon />
                                        </div>

                                        <TextField
                                            onChange={this.onChange}
                                            value={this.state.email}
                                            error={errors.email}
                                            id="email"
                                            type="email"
                                            className={classnames("", {
                                                invalid: errors.email || errors.emailnotfound
                                            })}
                                            placeholder="Email"
                                            fullWidth={true}
                                        />

                                        <span className="red-text">
                                            {errors.email}
                                            {errors.emailnotfound}
                                        </span>

                                        <br />
                                        <br />

                                        <div>
                                            <LockOpenIcon />
                                        </div>

                                        <TextField
                                            onChange={this.onChange}
                                            value={this.state.password}
                                            error={errors.password}
                                            id="password"
                                            type="password"
                                            className={classnames("", {
                                                invalid: errors.password || errors.passwordincorrect
                                            })}
                                            placeholder="Password"
                                            fullWidth={true}
                                        />
                                        <span className="red-text">
                                            {errors.password}
                                            {errors.passwordincorrect}
                                        </span>

                                        <br />
                                        <br />

                                        <TextField
                                            fullWidth={true}
                                            id="standard-select-currency"
                                            select label="Select"
                                            value={this.state.type}
                                            onChange={this.handleChange}
                                            helperText="Please select your user type">
                                            {types.map(option => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </TextField>

                                        <div className="w-100">
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={this.checked1}
                                                        onChange={this.handleChange1}
                                                        value="checked1"
                                                        color="primary"
                                                    />
                                                }
                                                label="Remember me"
                                            />
                                        </div>
                                            <p>forgot password</p>

                                    </DialogContent>

                                    <DialogActions>
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            type="submit">
                                            Sign in
                                        </Button>

                                        <Button onClick={this.handleClose2} color="primary">
                                            Cancel
                                        </Button>
                                    </DialogActions>
                                </form>
                            </Dialog>
                        </Box>
                   
                     <ResourceSection />
                       
                        <Footer />
                    </Box>
                </>
        );
    }
}



const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(
    mapStateToProps)(withRouterCompat(Landing));
